import { UserOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { dataFetchError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import { Button, Select, Tag } from "antd";
import { toJalaali } from "jalaali-js";
import moment from "moment/moment";
import ExportExcel from "../../../../Util/ExportExcel";
import CheckPermission from "../../../../Util/CheckPermission";

const Admins = ({ LoadingSetter, ClearLoading, loading, permissions }) => {
  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([
    { value: "Author", text: "نویسنده" },
    { value: "Editor", text: "ویراستار" },
    { value: "SuperAdmin", text: "ادمین" },
  ]);
  const columns = [
    {
      title: "نام",
      dataIndex: "firstname",
      searchable: true,
    },
    {
      title: "نام خانوادگی",
      dataIndex: "lastname",
      searchable: true,
    },
    {
      title: "نام کاربری",
      dataIndex: "username",
      searchable: true,
    },

    {
      title: "نقش",
      dataIndex: "role",
      filters: roles,
      onFilter: (value, record) => {
        return value === record.role;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select>
              {roles.map((el) => {
                return (
                  <Select.Option value={el.value} key={el.value}>
                    {el.text}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (text, row) => <div>{text.text}</div>,
    },
  ];
  const loadData = () => {
    LoadingSetter();
    api
      .get("/statuses", { params: { take: 1000, skip: 0 } })
      .then((res) => {
        setData(res.data);
        ClearLoading();
      })

      .catch((err) => {
        console.log(err);
        ClearLoading();
        dataFetchError();
      });
  };

  useEffect(() => {
    loadData();
    // loadFlagsData();
  }, []);
  const exportData = () => {
    const json = data.map((user) => {
      const newUser = {};
      Object.keys(user).forEach((key) => {
        let title = null;
        columns.forEach((c) => {
          if (c.dataIndex === key) {
            title = c.title;
          }
        });
        if (title) {
          newUser[title] = user[key];
        }
      });
      return newUser;
    });
    ExportExcel(json, "گزارش کاربران");
  };
  return (
    <>
      <DataTable
        id="UsersReport"
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        editable
        keepPageOnSave
        hideComment
        hideErrorReport
        header={{
          title: "ادمین‌ها",
          avatar: { icon: <UserOutlined />, size: "large" },
          extra: CheckPermission("export_excel", permissions) && (
            <Button onClick={exportData}>خروجی اکسل</Button>
          ),
        }}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Admins);
